module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "cont"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/07_foreword#fore"
    }
  }, [_c('i', [_vm._v("Foreword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/08_theroswell#therose"
    }
  }, [_c('i', [_vm._v("The Roswell Rashomon Effect")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/09_preface#pref"
    }
  }, [_c('i', [_vm._v("Preface—Roswell in Perspective: Reexamining the Case in 2020")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/10_chapter01#c01",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 1:")]), _vm._v(" The Ultimate Cold Case File")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/11_chapter02#c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 2:")]), _vm._v(" Roswell: The Undeniable Truths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/12_chapter03#c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 3:")]), _vm._v(" Covering Up the Story of the Millennium")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/13_chapter04#c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 4:")]), _vm._v(" Due Process Be Damned")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/14_chapter05#c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 5:")]), _vm._v(" First Amendment Violations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/15_chapter06#c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 6:")]), _vm._v(" Threats of Leavenworth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/16_chapter07#c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 7:")]), _vm._v(" The Evidence Is Secured Away from Roswell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/17_chapter08#c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 8:")]), _vm._v(" Flailing in the Dark: The Officers Take Charge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/18_chapter09#c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 9:")]), _vm._v(" Searching for the On Button")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/19_chapter10#c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 10:")]), _vm._v(" Washington Looks into Roswell . . . or Did They?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 11:")]), _vm._v(" Touched by Roswell")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/20_chapter12#c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 12:")]), _vm._v(" Deathbed Confessions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/21_chapter13#c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 13:")]), _vm._v(" When Death Is Not the Final Arbiter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/22_chapter14#c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 14:")]), _vm._v(" In Their Own Words, the Witnesses Speak Out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter15#c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("CHAPTER 15:")]), _vm._v(" The Most Important Trial of the Millennium")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "1.5pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/24_notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/25_index#inde",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f91d1b24","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_contents.vue
// module id = 72
// module chunks = 0